import { HttpClient } from "./httpClient";
import { toast } from "../../commonComponents/Toast";
import { initializeValuesServerWarnings } from "../actions/initializeValues";
import store from "../store";
import { updateAdditonDeduction, updateAndSaveTotals, updateTheseFieldsTotals } from "../actions/DescriptionOfMerchandiseActions.js";
import get from 'lodash/get';
import trim from 'lodash/trim';
import { getQueryVariable } from "../../apiCalls/jobInfo";

const mapHeaderPartyTypeToSameAsValue = {
  CONSIGNEE: "consigneeAsImporter",
  BUYER: "buyerAsImporter",
  MANUFACTURER: "manufacturerAsShipper",
  STUFFER: "containerStufferAsManufacturer",
  SHIP_TO: "notifyPartyAsImporter",
  // SELLER: 'sellerAsShipper',
  CONSOLIDATOR: "consolidatorAsShipper",
};

const isdutiesQuery = (eventMessage) => {
  // console.log('isdutiesQuery: ', eventMessage);
  var valueIwant_l =null;
  valueIwant_l = valueIwant_l || !!get(eventMessage,'entryTypeInfo.tibInfo',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].countryOfOrigin',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].productClaimCode',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].dutyRate',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].duty',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].dutyOverrideFlag',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].enteredValue',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].mpf.fee',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].hmf.fee',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].IRTax',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].additionalDuties',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].otherRate',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].specificRate',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].manifestQuantity.quantity',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].manifestQuantity.units',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].additionalQuantity.quantity',null);
  valueIwant_l = valueIwant_l || !!get(eventMessage,'descriptionOfMerchandise.merchandiseLineItems[0].merchandiseDuties[0].additionalQuantity.units',null);

  
  
  
  
  return (!!valueIwant_l);
}

export const saveLineItemPsc = (merchandiseId, lineCodes) => {
  if(!window.pscShipmentId){
    console.error("PSC ShipmentId doesnot exist");
  }
  let dataSent = saveEvent({
    psc: {
      lineItem: [{
        merchandiseId,
        lineCodes
      }]
    },
    shipmentId: window.pscShipmentId,
  });
  //console.log("SAVE Line Item PSC ::: ", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveEvent = (eventMessage, extraParameters) => {
  function trimEVERYTHING(objectToget,depth){
    if(depth>10)return;//recursion failsafe
    if(!objectToget)return;
    if(typeof objectToget != "object")return;
    for(let thekeys of Object.keys(objectToget)){
      if(typeof objectToget[thekeys] == 'object'){
        trimEVERYTHING(objectToget[thekeys],depth+1);
      } else if(typeof objectToget[thekeys] == 'string'){
        objectToget[thekeys] = objectToget[thekeys].trim();
      }
    }
  }
  if(!extraParameters?.notrimming){
    trimEVERYTHING(eventMessage,0)
  }
  return({
    eventType: 
    extraParameters?.eventType?extraParameters.eventType:
    isdutiesQuery(eventMessage)?"SAVE_ENTRY_SUMMARY_DUTIES":"SAVE_ENTRY_SUMMARY_FORM",
    eventTime: Date.now(),
    eventMessage,
  })
};

const saveEntrySummaryDutiesEvent_vc = (eventMessage, extraParameters) => ({
  eventType: (extraParameters?.eventType)? extraParameters.eventType :"SAVE_ENTRY_SUMMARY_DUTIES",
  eventTime: Date.now(),
  eventMessage,
});

const saveCensusEvent = (eventMessage) => ({
  eventType: "SAVE_CENSUS_WARNINGS",
  eventTime: Date.now(),
  eventMessage,
});

const savePGAFormEvent = (eventMessage) => {
  for(let pgaitem of (eventMessage.pgaItems ||[])){
    if(pgaitem){
      for(let oneKey of Object.keys(pgaitem)){
        let isemptyobj = !pgaitem[oneKey] || (typeof pgaitem[oneKey] == "object" && Object.keys(pgaitem[oneKey]).length == 0);
        if(isemptyobj)delete pgaitem[oneKey];
        if (!pgaitem.hasOwnProperty("value")) {
          pgaitem["value"] = "";
        }
      }
    }
  }
  return ({
  eventType: "SAVE_PGA_FORM",
  eventTime: Date.now(),
  eventMessage,
})};

const deleteEvent = (eventMessage) => ({
  eventType: "DELETE_ENTRY_SUMMARY_ENTITY",
  eventTime: Date.now(),
  eventMessage,
});

export const deletePgaOnProgramChange = (eventMessage) => {
  let requestParams = deleteEvent(eventMessage);
  setTimeout(()=>{
    return HttpClient.post(requestParams);
  },1500)
  return HttpClient.post(requestParams);
};

const buildRequestAddress = (storeAddress) => {
  if (!storeAddress) return [];
  let addressInfo = [];
  for (let type in storeAddress) {
    if (type === "STREET_NAME") {
      let splitStreet = storeAddress[type].split(" ");
      if (parseInt(splitStreet[0])) {
        addressInfo.push({
          type: "STREET_NUMBER",
          information: splitStreet[0],
        });
        addressInfo.push({
          type: "STREET_NAME",
          information: splitStreet.slice(1).join(" "),
        });
      } else {
        addressInfo.push({
          type: "STREET_NUMBER",
          information: " ",
        });
        addressInfo.push({
          type: "STREET_NAME",
          information: storeAddress[type],
        });
      }
    } else {
      if(typeof storeAddress[type] !== "object"){
        addressInfo.push({
          type: type,
          information: storeAddress[type],
        });
      }
    }
  }
  for(let oneaddress of addressInfo){
    if(!oneaddress.information){
      oneaddress.information= " ";
    }
  }
  return addressInfo;
};

export const HttpPostRequest = (requestParams) => {
  const pscLineCodes = get(requestParams, 'eventMessage.psc.lineCodes', []);
  const isPscBulkLineReason =
    Array.isArray(pscLineCodes) && pscLineCodes.length > 1;
  return HttpClient.post(requestParams)
    .then((res) => {
      if (res.data.eventMessage.code  && res.data.eventMessage.code !== 200) {
        console.error("errorCode :" + res.data.eventMessage.code, "eventMessage :" + res.data.eventMessage.msg);
        console.log("eventMessage :" + res.data.eventMessage.msg);
        const errLead = isPscBulkLineReason
          ? 'Could not copy PSC reasons to all lines'
          : 'Data not saved';
        toast.error(errLead+(res.data.eventMessage.msg?`:    ${res.data.eventMessage.msg} `:'. Try again later'));
      }

      let serverwarnobj = {serverwarnings_tm: get(res,"data.eventMessage.warnings",[])};
      let callsthatrunvalidation = [//the backend doesn't tell us if it ran the validation for some reason, so there's a list of fields that run it
        "eventMessage.bolInfo.bol.boltype"
      ]
      let ranvalidation = false
      for(let onecall of callsthatrunvalidation){
        if(get(requestParams,onecall,false))ranvalidation=true;
      }
      if(ranvalidation){
        store.dispatch(initializeValuesServerWarnings(serverwarnobj))
        setTimeout(()=>{
          document.getElementById("VALIDATE_FORM_BUTTON") &&
          document.getElementById("VALIDATE_FORM_BUTTON").click();
        },50)
      };

      let whitelistedAPIForUpdating = (
        res.data.eventType ==  "SAVE_ENTRY_SUMMARY_DUTIES" ||
        res.data.eventType == "DELETE_ENTRY_SUMMARY_ENTITY");
      if (res.data.eventType == "PRORATE_CHARGES") {
        store.dispatch(updateTheseFieldsTotals(
          res.data.eventMessage,
          {
            shipment_AAA: ["charges", "totalCharges"],
            invoice_AAA: ["charges", "totalCharges"],
            merchandise_AAA: ["charges", "totalCharges"],
          }
          ));
          console.log("PRORATE UPDATE!!!");
      
      }
      if(get(res,'data.eventMessage.hmf.fee',null) && whitelistedAPIForUpdating){
    
        store.dispatch(updateAndSaveTotals(
          res.data.eventMessage.hmf.fee, 
          res.data.eventMessage.mpf.fee, 
          res.data.eventMessage.duty, 
          res.data.eventMessage.fee, 
          res.data.eventMessage.tax, 
          res.data.eventMessage.additionalDuties,
          res.data.eventMessage.bondedAdDutyAmt,
          res.data.eventMessage.bondedCvdDutyAmt,
          res.data.eventMessage.cashAdDutyAmt,
          res.data.eventMessage.cashCvdDutyAmt,
          res.data.eventMessage.grandTotal,
          res.data.eventMessage
          ));
          console.log("TOTALS UPDATE!!!");
      }
      return res;
    })
    .catch((error) => {
      console.log("ERROR:: ", error, Object.keys(error));
      const errLead = isPscBulkLineReason
        ? 'Could not copy PSC reasons to all lines. '
        : 'Critical! Data not saved. ';
      toast.error(errLead + error);
    });
};

export const saveNewParty = (type,midObj, shipmentId, manifestId) => {
  let addressObject = {};
  for(let oneInfo of (midObj.addressinfo ||[])){
    addressObject[oneInfo.type] = oneInfo.information;
  }
  let dataSent = {
    "eventMessage":{
       "graph":{
          "actor01":[
             {
                "meta":{
                   "id":`$${type}-1`
                },
                "data":{
                   "ACTOR_TYPE_ID":type,
                   "NAME":midObj.name,
                   "MANIFEST_ID":manifestId || undefined,
                   ...addressObject
                }
             }
          ],
          "shipmentId":shipmentId
       }
    },
    "eventType":"SET_CORE_DATA",
    "eventTime":Date.now()
 };
  console.log("saveNewParty Name", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveNewManufacturer = (midObj) => {
  let dataSent = {
    "eventType": "SAVE_ENTRY_SUMMARY_FORM",
    "eventTime": Date.now(),
    "eventMessage": {
      "newlyAddedManufacturerUnderPartiesTab": {
        
        "name": midObj.name,
        "addressinfo": midObj.addressinfo,
        // "headerPartyType": "MANUFACTURER",
        "mid": midObj.mid
      },
      "shipmentId": window.pscShipmentId || window.shipmentId,
    }
  };
  console.log("saveNewManufacturer Name", dataSent);
  return HttpPostRequest(dataSent);
};

export const removeAManufacturer = (myremovalId) => {
  console.log('listOfManufacturers, myremovalId: ', myremovalId);
  
  let dataSent = {
    "eventType": "SAVE_ENTRY_SUMMARY_FORM",
    "eventTime": Date.now(),
    "eventMessage": {
      "removedManufacturerHeaderIdUnderPartiesTab": myremovalId,
      "shipmentId": window.pscShipmentId || window.shipmentId,
    }
  };
  console.log("saveNewManufacturer Name", dataSent);
  return HttpPostRequest(dataSent);
}

export const savemanufacturerIdforManufacturer = (myheaderid,manufacturerId,headerpartytype) => {
  
  let dataSent = {
    "eventType": "SAVE_ENTRY_SUMMARY_FORM",
    "eventTime": Date.now(),
    "eventMessage": {
      importer: {
        headerParties:[{
          "mId": manufacturerId,
          "headerId": myheaderid,
          "headerPartyType": headerpartytype,

        }]

      },
      "shipmentId": window.pscShipmentId || window.shipmentId,
    }
  };
  return HttpPostRequest(dataSent);
  // console.log('dataSent: ', dataSent);
}
export const associateManufacturerIdtoLineItem = (
  invoiceId,
  merchandiseId,
  mymann) => {
  let dataSent = {
    "eventType": "SAVE_ENTRY_SUMMARY_DUTIES",
    "eventTime": Date.now(),
    "eventMessage": {
      "descriptionOfMerchandise": {
        "entrySummaryInvoices": [
          {
            "invoiceId": invoiceId,
            "merchandiseLineItems": [
              {
                "merchandiseId": merchandiseId,
                "manufacturerId": mymann.mId,
                "manufacturerHeaderIdUnderPartiesTab": mymann.headerId
              }]
          }
        ]
      },
      "shipmentId": window.pscShipmentId || window.shipmentId,
    }
  }
  return HttpPostRequest(dataSent);
}

export const saveImporterName = (name, importerId) => {
  let dataSent = saveEvent({
    importer: {
      importerId,
      name,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE Importer Name", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveImporterAddress = (address, importerId) => {
  let dataSent = saveEvent({
    importer: {
      importerId,
      addressInfo: buildRequestAddress(address),
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  },{notrimming: true});
  console.log("SAVE Importer Address", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveImporterAddressAndName = (name, address, importerId,importer) => {
  let dataSent = saveEvent({
    importer: {
      importerId,
      name: name || " ",
      addressInfo: buildRequestAddress(address),
      importerIdInfo: importer.importerIdInfo,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  },{notrimming: true});
  console.log("SAVE Importer Address", dataSent,importer);
  return HttpPostRequest(dataSent);
};

export const saveConsigneeAddressAndName = (consignee) => {
  let dataSent = saveEvent({
    importer: {
      consignee: {
        name: consignee.name || " ",
        addressInfo: buildRequestAddress(consignee.addressInfo),
        consigneeId: consignee.consigneeId,
        consigneeIdInfo: consignee.consigneeIdInfo
      },
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  },{notrimming: true});
  console.log("SAVE Consignee Address", dataSent, consignee);
  //ALL CONSIGNEE SAVES GO THROUGH ERE
  return HttpPostRequest(dataSent);
};

export const saveHeaderPartiesByHeaderId = (headerParties, headerId) => {
  let requestHeaderparties = [];
  let currentHeaderParty = headerParties.find((a)=>a.headerId==headerId);
  if(!currentHeaderParty)return;
  let newParty = Object.assign({}, { ...currentHeaderParty });
  newParty.name = newParty.name || " ";
  newParty.addressInfo = buildRequestAddress(currentHeaderParty.addressInfo);
  requestHeaderparties.push(newParty);

  let dataSent = saveEvent({
    importer: {
      headerParties: requestHeaderparties,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  },{notrimming: true});
  console.log("SAVE Header Parties", dataSent);
  return HttpPostRequest(dataSent);
};

// Saves header parties. If only 1 is needed to be saved, pass  the index. If all need to be saved, pass -1
export const saveHeaderParties = (headerParties, index) => {
  let requestHeaderparties = [];
  if (index !== -1) {
    let newParty = Object.assign({}, { ...headerParties[index] });
    newParty.name = newParty.name || " ";
    newParty.addressInfo = buildRequestAddress(headerParties[index].addressInfo);
    requestHeaderparties.push(newParty);
  } else {
    requestHeaderparties = headerParties.map((party) => {
      let newParty = Object.assign({}, { ...party });
      newParty.name = newParty.name || " ";
      newParty.addressInfo = buildRequestAddress(party.addressInfo);
      return newParty;
    });
  }
  let dataSent = saveEvent({
    importer: {
      headerParties: requestHeaderparties,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  },{notrimming: true});
  console.log("SAVE Header Parties", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveImporterField = (field, value) => {
  let dataSent = saveEvent({
    importer: {
      [field]: value,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE Importer Field", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveSameAs = (field, value) => {
  let dataSent = saveEvent({
    importer: {
      sameAsFlags: {
        [mapHeaderPartyTypeToSameAsValue[field]]: value,
      },
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE SameAs Field", dataSent);
  return HttpPostRequest(dataSent);
};


export const deleteHeaderParty = (shipmentId, partyId) => {
  let dataSent = {
    "eventMessage":{
       "graph":{
          "shipmentId":shipmentId,
          "actor01":{
             "meta":{
                "id":partyId,
                "archive":1,
                "type":"actor"
             }
          }
       }
    },
    "eventType":"SET_CORE_DATA",
    "eventTime":Date.now()
 }
  return HttpPostRequest(dataSent);
};


export const saveBondInfo = (field, value) => {
  let dataSent = saveEvent({
    bondInfo: {
      [field]: value,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE Bond Info", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveDescriptionOfMerchandiseField = (field, value) => {
  let extraParams = { }
  if(field == "totalCharges"){
    extraParams.eventType = "PRORATE_CHARGES";
  }
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      [field]: value,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  },extraParams);
  console.log("SAVE DescriptionOfMerchandiseField", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveDutyFromHts = (merchandiseId, merchandiseDutyId, duty, isCommodityDuty) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId: merchandiseId,
          merchandiseDuties: [
            {
              merchandiseDutyId: merchandiseDutyId,
              duty: duty,
              isCommodityDuty,
            },
          ],
        },
      ],
    },
    shipmentId: window.pscShipmentId || window.shipmentId
  });
  console.log("SAVE_DUTY_FROM_HTS", dataSent);
  return HttpPostRequest(dataSent);
};
export const saveMerchandiseObject = (mystate, shipmentId) => { 
  let dataSent = saveEntrySummaryDutiesEvent_vc({
    shipmentId: window.pscShipmentId || shipmentId,
    descriptionOfMerchandise: {
      entrySummaryInvoices: mystate.entrySummaryInvoices,
    }
  });
  return HttpPostRequest(dataSent);
}

export const handleHoldStatus = (eventMessage) => {
  const req = { eventMessage, eventType: 'SAVE_B3_FORM' };
  return HttpPostRequest(req);
};

export const saveDutyAndFeeFromHts = (merchandiseId, merchandiseDutyId, duty, hmf, mpf, isCommodityDuty) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId: merchandiseId,
          merchandiseDuties: [
            {
              merchandiseDutyId: merchandiseDutyId,
              duty: duty,
              hmf: {
                fee: hmf,
              },
              mpf: {
                fee: mpf,
              },
              isCommodityDuty,
            },
          ],
        },
      ],
    },
    shipmentId: window.pscShipmentId || window.shipmentId
  });
  console.log("SAVE_FEE_FROM_HTS", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveDescriptionOfMerchandiseLineItem = (merchandiseId, invoiceId , field, value, additionalData) => {
  if (value === true) value = 1;
  else if (value === false) value = 2;
  else if (value === "NONE") value = "_BLANK_";
  if(typeof value == "string")value=value.trim();
  if(typeof value == "object" && value){
    value = JSON.parse(JSON.stringify(value))
    if(value && value.importerAdditionalDeclarationDetail && value.importerAdditionalDeclarationDetail.length ==0){
      value.importerAdditionalDeclarationDetail.push(
        {
          "typeCode": "ALUMINUM_SMELT_AND_CAST_COUNTRY_DETAIL",
          "aluminumSmeltAndCastCountryDetail": {
            "isUsProduct": " ",
            "isPrimaryCountryOfSmeltApplied": "no",
            "primaryCountryOfSmelt": " ",
            "isSecondCountryOfSmeltApplied": "no",
            "secondaryCountryOfSmelt": " ",
            "countryOfCast": " "
          }
        })
    }

  }
  let values = {
    merchandiseId,
    [field]: value,
  };
  if(additionalData?.addedParametersx){
    values = {...values, ...additionalData.addedParametersx}
  }
  if(field == 'manufacturerId'){
    values.manufacturerHeaderIdUnderPartiesTab = additionalData.manufacturerHeaderIdUnderPartiesTab
  }
  let dataSent = saveEntrySummaryDutiesEvent_vc({
    descriptionOfMerchandise: {
      entrySummaryInvoices: [{
        invoiceId,
      merchandiseLineItems: [
        values
      ],
    }],
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE DescriptionOfMerchandiseField8899", dataSent);

  return HttpPostRequest(dataSent);
};



export function loadCurrenciesAssociatedWithCountry(countryOfExport) {
  let dataSent = {
    "eventMessage": {  
          "isoCountryCode": countryOfExport
    },
    "eventTime": Date.now(),
    "eventType": "GET_CURRENCY_CODE"
  }
  return HttpClient.custom({
    data:dataSent
  })

}
export function loadCurrenciesConversionRates(countryOfExport,countryOfExportCurrency,exchangeDateMMDDYY) {
  let dataSent = {
    "eventMessage": {  
          "fromIsoCountryCode": countryOfExport,
          "fromIsoCurrencyCode":countryOfExportCurrency,
          "toIsoCountryCode": "US",
          "toIsoCurrencyCode": "USD",
          "exchangeDate": exchangeDateMMDDYY
    },
    "eventTime": Date.now(),
    "eventType": "GET_CURRENCY_EXCHANGE_RATE"
  }
  return HttpClient.custom({
    data:dataSent
  })

}

export const saveInvoiceLineItemFeild = (invoiceId, field, value) => {


  let dataSent = saveEntrySummaryDutiesEvent_vc({
    descriptionOfMerchandise: {
      entrySummaryInvoices: [{
        invoiceId,
        [field]: value,
        shipmentId: window.pscShipmentId || window.shipmentId,
      }],
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  }
  ,
    {eventType : field=="totalCharges"?"PRORATE_CHARGES":null}
  );
  console.log("SAVE DescriptionOfMerchandiseField", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveInvoiceLineItemFeildBetterObject = (invoiceId, field) => {


  let dataSent = saveEntrySummaryDutiesEvent_vc({
    descriptionOfMerchandise: {
      entrySummaryInvoices: [{
        invoiceId,
        ...field,
        shipmentId: window.pscShipmentId || window.shipmentId,
      }],
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE DescriptionOfMerchandiseField", dataSent);
  return HttpPostRequest(dataSent);
};



export const saveInvoiceLineItemFeildObject = (invoiceId, field1, value1,field2, value2,field3, value3) => {


  let dataSent = saveEntrySummaryDutiesEvent_vc({
    descriptionOfMerchandise: {
      entrySummaryInvoices: [{
        invoiceId,
        [field1]: value1,
        [field2]: value2,
        [field3]: value3,
        shipmentId: window.pscShipmentId || window.shipmentId,
      }],
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE DescriptionOfMerchandiseField", dataSent);
  return HttpPostRequest(dataSent);
};





// Saves all Duties of a line item
export const saveLineItemDuties = (merchandise, lineitemIndex) => {
  let lineItem = merchandise.merchandiseLineItems[lineitemIndex];
  let eventMsg = {
    descriptionOfMerchandise: {
    //  totalValue: merchandise.totalValue,
      merchandiseLineItems: [
        {
          merchandiseId: lineItem.merchandiseId,
          merchandiseDuties: lineItem.merchandiseDuties.map((merchandiseDuty) => {
            if (merchandiseDuty.isCommodityDuty === 2) {
              return {
                merchandiseDutyId: merchandiseDuty.merchandiseDutyId,
                isCommodityDuty: merchandiseDuty.isCommodityDuty,
                duty: merchandiseDuty.duty,
                dutyRate: merchandiseDuty.dutyRate,
              };
            } else {
              return {
                merchandiseDutyId: merchandiseDuty.merchandiseDutyId,
                isCommodityDuty: merchandiseDuty.isCommodityDuty,
                enteredValue: merchandiseDuty.enteredValue,
                duty: merchandiseDuty.duty,
                dutyRate: merchandiseDuty.dutyRate,
                mpf: merchandiseDuty.mpf,
                hmf: merchandiseDuty.hmf,
              };
            }
          }),
        },
      ],
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  }
  if(lineItem.articleSetId){
    eventMsg.descriptionOfMerchandise.merchandiseLineItems[0].articleSetId = merchandise.articleSetId;
  }
  let dataSent = saveEvent(eventMsg);
  console.log("SAVE saveLineItemDuties", dataSent);
  return HttpPostRequest(dataSent);
};

// Saves all specified fields in addtional fields of the Duty Item

export const saveDescriptionOfMerchandiseDutyItemArray = (invoiceId,merchandiseItemList) => {
  // Transform merchandiseItemList to match the new API structure
  const merchandiseData = merchandiseItemList.map((item, index) => ({
    meta: {
      id: item?.merchandiseId
    },
    data: {
      MERCHANDISE_ID: item?.merchandiseId,
      ESTIMATE_WEIGHT: item?.grossWeight?.weight || "",
      WEIGHT_UNITS: item?.grossWeight?.weightUnits || ""
    }
  }));

  let dataSent = {
    "eventType": "SET_CORE_DATA",
    "eventMessage": {
      "graph": {
        "shipmentId": window.pscShipmentId || window.shipmentId,
        "merchandise01": merchandiseData
      }
    },
    "eventTime": Date.now()
  };

  console.log("SAVE DescriptionOfMerchandiseField 465", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveDescriptionOfMerchandiseDutyItem = (merchandiseId,invoiceId, merchandiseDutyId, additionalFields, isCommodityDuty, articleSetId, additionalLineItemFields,extraEvent={}) => {
  let dataSent = saveEntrySummaryDutiesEvent_vc({
    descriptionOfMerchandise: {
      entrySummaryInvoices: [
        {
          invoiceId,
      merchandiseLineItems: [
        {
          ...additionalLineItemFields,
          merchandiseId,
          articleSetId,
          merchandiseDuties: [
            {
              ...additionalFields,
              merchandiseDutyId,
              isCommodityDuty,
            },
          ],
        },
      ],
    }]
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  },extraEvent);

  console.log("SAVE DescriptionOfMerchandiseField 3", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveDutiesNonMerchandise = (eventMsg) => {
  eventMsg.shipmentId = window.shipmentId;
  let dataSent = saveEntrySummaryDutiesEvent_vc(eventMsg);
  return HttpPostRequest(dataSent);
}

export const saveEntryTypeField = (field, value) => {
  let dataSent = saveEvent({
    entryTypeInfo: {
      [field]: value,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE EntryType Field", dataSent);
  return HttpPostRequest(dataSent);
};

export const calcEntryDateToPSPDDate = (dateAsMMDDYYYY,shipmentId, fullName) =>{
  return HttpClient.post(
    {
      "eventMessage": {
          "entryDate": dateAsMMDDYYYY,
          "shipmentId": shipmentId,
          "brokerName": fullName
      },
      "eventTime": Date.now(),
      "eventType": "CALCULATE_PRELIMINARY_STATEMENT_PRINT_DATE"
  })
}

export const saveEntryTypeDateField = (field, value) => {
  let dataSent = saveEvent({
    entryTypeInfo: {
      [field]: {
        epochs: value,
      },
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE EntryType Date Field", dataSent);
  return HttpPostRequest(dataSent);
};
export const saveTransportationField = (field, value) => {
  value = value === "" ? "_BLANK_" : value;
  console.log({ field, value });

  let isObject = Boolean(typeof value === "object" && value);
  let dataSent = saveEvent({
    transportInfo: isObject
      ? value
      : {
          [field]: value,
        },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  //console.log("SAVE Transportation Field", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveTransportationDateField = (field, value) => {
  let dataSent = saveEvent({
    transportInfo: {
      [field]: {
        epochs: value,
      },
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE Transportation Date Field", dataSent);
  return HttpPostRequest(dataSent);
};


export const saveReconField = (field, value) => {
  value = value === "" ? "_BLANK_" : value;
  let dataSent = saveEvent({
    ...value,
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  //console.log("SAVE Recon Field", dataSent);
  return HttpPostRequest(dataSent);
};



export const saveBOLInfoObject = (fieldc,objectX) => {
  const skipTrimming = objectX?.currentLocationOfGood === " ";
  let dataSent = saveEvent({
    [fieldc]: objectX,
    shipmentId: window.pscShipmentId || window.shipmentId,
  },{...(skipTrimming ? {notrimming: true} : {})});
  console.log("SAVE BOL Object", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveBOLInfoField = (field, value) => {
  if(typeof value == "object")
    value.boltype = value.boltype || "MASTER_BOL";
  let dataSent = saveEvent({
    bolInfo: {
      [field]: value,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE BOL Field", dataSent);
  return HttpPostRequest(dataSent);
};
export const saveBOLInfoDateField = (field, value) => {
  let dataSent = saveEvent({
    bolInfo: {
      [field]: {
        epochs: value,
      },
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE Transportation Date Field", dataSent);
  return HttpPostRequest(dataSent);
};

export const updateEngineBolTable = (manifestId, bolTableField, newFieldValue, transactionId) =>{
  return HttpPostRequest(
  {
    "eventType": "UPDATE_BOL",
    "eventTime": Date.now(),
    "eventMessage": {
      "manifestId": manifestId, // replace with actual id,
      transactionId: transactionId,
      // "archive": "true", // for delete only
      [bolTableField]: newFieldValue // update value
    }
  }
  )
}

export const deleteFromEngineBolTable = ({shipmentId, manifestId, entryRelationshipId}) => {
  return HttpPostRequest(
    {
      "eventType": "UPDATE_BOL",
      "eventTime": Date.now(),
      "eventMessage": {
        "transactionId": shipmentId,
        "manifestId": manifestId,
        "archive": "true",
        entryRelationshipId
      }
    }
  )
}

export const mergeshipmentMbolsToTransaction = (listOfShipmentIds, transactionId, isTarget) => {
  if(isTarget){
    return HttpPostRequest(
      {
        "eventType": "ADD_ENTRY_IN_CONSOLIDATED_ENTRY_TRANSACTION",
        "eventMessage": {
          "parentTransactionId":  transactionId, // current transaction
          "childTransactionIds":  listOfShipmentIds // selected transactions from popup
      }
      }
    )
  }
  return HttpPostRequest(
    {
      "eventType": "MERGE_SHIPMENT",
      "eventMessage": {
        "destShipmentId": transactionId,
        "sourceShipmentIds": listOfShipmentIds
      }
    }
  )
}

export const searchForMbols = (searchText, propsForSearchForMbols, isTarget, ReconInfo) => {
 
  if(isTarget){
    return  HttpPostRequest(
      {
        "eventType": "GET_TRANSACTION_FILING_GROUP_LIST",
        "eventMessage": {
          "offset": "0",
          "limit": "100",
          "transactionType": "ENTRY",
          "filter": {
              "companyGuid": propsForSearchForMbols?.customerCode, // customer_code
              "modeOfTransport": propsForSearchForMbols?.modeOfTransport, // modeOfTransport
              "portOfUnlading": propsForSearchForMbols?.portOfUnlading, // portOfUnlading 
              "vesselName":  propsForSearchForMbols?.importingCarrier || "", // importingCarrier
              "entryTransactionStatus": "TEMP_COMPLETED", // constant
              "topLevelFilter": "All",
              "reconType" :  trim(ReconInfo?.taReconCode) || "N"
          },
          "sort": {
              "eta": "asc"
          }
      },
      }
    )
  }
  const {importingCarrier, ...consolidationMatchUS} = propsForSearchForMbols ;
  return HttpPostRequest(
    {
      "eventType": "MANIFOLD_SEARCH_SHIPMENTS",
      "eventMessage": {
        "sort": {
            "limit": 100
        },
        "consolidationMatchUS": consolidationMatchUS,
        // "state": {
        //   "countryOfBusiness": ["US"],
        //   "customerCode": [customerCode],
        // //  "mbol": { "leaf": { "stringLike": { "op": "WILD", "value": `*${searchText}*` } } },
        //   "modeOfTransport": ["OCEAN"],
        // },
        "allowedSearchStatusesByNodeType": 
          {"US:ENTRY_ROOT" : {
              "code": ["NEW"]
            }
          }
        
      }
    }
  )
}

export const saveContainer = (id, field, value,containerNumber) => {
  value = value === "" ? "_BLANK_" : value;
  let dataSent = saveEvent({
    bolInfo: {
      // container: buildContainer(container)
      container: {
        [field]: value,
      },
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  if(containerNumber){
    dataSent.eventMessage.bolInfo.container.number = containerNumber;
  }
  if (id) {
    dataSent.eventMessage.bolInfo.container.containerId = id;
  }
  console.log("SAVE Container", dataSent);
  return HttpPostRequest(dataSent);
};

export const deleteContainer = (containerId, number) => {
  let dataSent = deleteEvent({
    shipmentId: window.shipmentId,
    bolInfo: {
      container: [
        {
          containerId: containerId,
          number: number,
        },
      ],
    },
  });
  console.log("DELETE Container", dataSent);
  return HttpPostRequest(dataSent);
};

// Saves totals for Merchandise section
// export const saveTotals = (duty, fee, grandTotal, hmf, mpf, tax, additionalDuties) => {
//   let dataSent = saveEvent({
//     additionalDuties,
//     duty: duty,
//     fee: fee,
//     grandTotal: grandTotal,
//     hmf: {
//       fee: hmf,
//     },
//     mpf: {
//       fee: mpf,
//     },
//     tax: tax,
//     shipmentId: window.shipmentId,
//   });
//   console.log("SAVE Merchandise Totals", dataSent);
//   return HttpPostRequest(dataSent);
// };

export const saveDutyAndFee = (merchandiseLineItems) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: merchandiseLineItems,
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE Merchandise Totals", dataSent);
  return HttpPostRequest(dataSent);
};

// Saves a PGA Item Array
export const savePGAItemField = (pgaGuid,PGAItemsArrayUncopied, merchandiseId, formType, extraPgaSaveOptions={}) => {
  const isPartsLibrary = getQueryVariable('page')==='parts-library' && getQueryVariable('onlyOneShipment') == 'true';
  if (isPartsLibrary){
    return;
  }
  
  let PGAItemsArray = JSON.parse(JSON.stringify(PGAItemsArrayUncopied))
  for(let pgaitem of PGAItemsArray){
    if(pgaitem && pgaitem.errorss){
      delete pgaitem.errorss;
    }
    if(pgaitem && pgaitem.regexx){
      delete pgaitem.regexx;
    }
  }
  let dataSent = savePGAFormEvent({
    shipmentId: window.shipmentId,
    merchandiseId: merchandiseId,
    customerEmail: window.customerEmail,
    formType,
    pgaGuid: (pgaGuid+"").indexOf("FAKEGUID_")>=0?"":pgaGuid,
    pgaItems: PGAItemsArray,
    ...extraPgaSaveOptions,
  });
    
  // Revert this code after https://klearnow.atlassian.net/browse/CORE-9957 is resolved

  if (!window.AdditionalSavesToDo) window.AdditionalSavesToDo = [];

  const saveFunctionForPGA = (myResolve) => {
    return () => {
       
        let deletingThisPGANoSave = ((window.deleting_GLOBALS_X || {})[`${merchandiseId}${formType}`] || 0) + 3000 > Date.now();
        if (deletingThisPGANoSave) return;
        window[`${pgaGuid}saveIsRunning`] = true;
        dataSent.eventTime = Date.now();
        myResolve(HttpPostRequest(dataSent).then((responsexx) => {
          if (responsexx.data.eventMessage.reload) {
            document.getElementById("RELOAD_THIS_PGA_" + pgaGuid) &&
              document.getElementById("RELOAD_THIS_PGA_" + pgaGuid).click();
          }
          if (window.AdditionalSavesToDo?.length) {
            window.AdditionalSavesToDo.shift()();
          } else {
            window[`${pgaGuid}saveIsRunning`] = false;
          }

          return responsexx;

        }))
    }
  };

  if (window[`${pgaGuid}saveIsRunning`]){
    return new Promise(myResolve => {
      window.AdditionalSavesToDo.push(saveFunctionForPGA(myResolve))
    });
  } else {

    return new Promise(myResolve => {
      return saveFunctionForPGA(myResolve)();
    })
  
  }
};

export const saveDeclarationSectionFieldObject = (payloadcc) => {
  let dataSent = saveEvent({
    ...payloadcc,
    shipmentId: window.pscShipmentId || window.shipmentId,
  });
  console.log("SAVE Declaration Section", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveCensusWarning = (fields) => {
  let dataSent = saveCensusEvent({
    fields: [fields],
    shipmentId: window.shipmentId,
  });
  console.log("SAVE Census Warning", dataSent);
  return HttpPostRequest(dataSent);
};

export const setdocPgaCorrectionOption = (pgaGuid, merchandiseId,formType, check) => {
  let dataSent = {
    eventMessage :{
    "merchandiseId": merchandiseId,
    pgaGuid: (pgaGuid+"").indexOf("FAKEGUID_")>=0?"":pgaGuid,
    "formType": formType,
    "pgaUpdateStatus": check?"checked":"unchecked",
    shipmentId: window.shipmentId,

    },
    
    eventTime: Date.now(),
    eventType: "SAVE_PGA_FORM",
  };
  return HttpPostRequest(dataSent);
};

export const savePgaFlag = (flag, merchandiseId, value, invoiceId,formType, pgaGuid) => {
  let dataSent = saveEvent({
    descriptionOfMerchandise: {
      entrySummaryInvoices: [{
        invoiceId,
        merchandiseLineItems: [
          {
            shipmentId: window.shipmentId,
            merchandiseId,
            "pgaFlagInfos": [
                {
                    "pgaType": formType,
                    "pgaGuid":  (pgaGuid+"").indexOf("FAKEGUID_")>=0?"":pgaGuid,
                    "pgaFlagName":  flag,
                    "pgaFlagStatus": value
                }
            ],
          },
        ],
        shipmentId: window.shipmentId,
      }],
    },
    shipmentId: window.shipmentId,
  });
  console.log("Update PGA Flag", dataSent);
  return HttpPostRequest(dataSent);
};

export const saveHeaderReason = (payload) => {
  if(!window.pscShipmentId){
    console.error("PSC ShipmentId doesnot exist");
  }
  let dataSent = saveEvent({
     "psc": {
        "headerCodes": [
          {
              "key": payload.tabName,
              "reasonCodes": payload.headerReason
          }
        ]
      },
    "shipmentId": window.pscShipmentId,
  });
  console.log("UPDATE HEADER READER", dataSent);
  return HttpPostRequest(dataSent);
}

export const saveLineReason  = (payload) => {
  if(!window.pscShipmentId){
    console.error("PSC ShipmentId doesnot exist");
  }
  let dataSent = saveEvent({
     "psc": {
        "lineCodes": [
          {
              "key": payload.merchandiseId,
              "reasonCodes": payload.lineReason
          }
        ]
      },
    "shipmentId": window.pscShipmentId,
  });
  console.log("UPDATE LINE REASONS", dataSent);
  return HttpPostRequest(dataSent);
}

const PSC_BULK_LINE_REASON_LOADER_ID = 'psc-bulk-line-reason-loader';
let pscBulkLineReasonSpinStyleAdded = false;

function showPscBulkLineReasonLoader() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(PSC_BULK_LINE_REASON_LOADER_ID)) return;
  if (!pscBulkLineReasonSpinStyleAdded && document.head) {
    const st = document.createElement('style');
    st.id = 'psc-bulk-line-reason-spin-keyframes';
    st.textContent =
      '@keyframes psc-bulk-line-reason-spin{to{transform:rotate(360deg)}}';
    document.head.appendChild(st);
    pscBulkLineReasonSpinStyleAdded = true;
  }
  const wrap = document.createElement('div');
  wrap.id = PSC_BULK_LINE_REASON_LOADER_ID;
  wrap.setAttribute('role', 'status');
  wrap.setAttribute('aria-busy', 'true');
  wrap.setAttribute('aria-live', 'polite');
  wrap.style.cssText = [
    'position:fixed',
    'inset:0',
    'z-index:100020',
    'display:flex',
    'align-items:center',
    'justify-content:center',
    'background:rgba(7,27,58,0.32)',
    'backdrop-filter:blur(2px)',
  ].join(';');
  const card = document.createElement('div');
  card.style.cssText = [
    'background:#fff',
    'padding:24px 32px',
    'border-radius:10px',
    'box-shadow:0 16px 48px rgba(7,27,58,0.2)',
    'display:flex',
    'flex-direction:column',
    'align-items:center',
    'gap:14px',
    'min-width:220px',
  ].join(';');
  const spinner = document.createElement('div');
  spinner.style.cssText = [
    'width:36px',
    'height:36px',
    'border:3px solid #e3f2fa',
    'border-top-color:#1765ae',
    'border-radius:50%',
    'animation:psc-bulk-line-reason-spin 0.75s linear infinite',
  ].join(';');
  const label = document.createElement('span');
  label.textContent = 'Applying reasons to all lines…';
  label.style.cssText =
    'font:600 14px "Open Sans",Segoe UI,sans-serif;color:#071b3a;text-align:center;';
  card.appendChild(spinner);
  card.appendChild(label);
  wrap.appendChild(card);
  document.body.appendChild(wrap);
}

function hidePscBulkLineReasonLoader() {
  if (typeof document === 'undefined') return;
  const el = document.getElementById(PSC_BULK_LINE_REASON_LOADER_ID);
  if (el && el.parentNode) {
    el.parentNode.removeChild(el);
  }
}

export const saveBulkLineReason = (lineCodes) => {
  if (!window.pscShipmentId) {
    console.error('PSC ShipmentId doesnot exist');
    toast.error(
      'PSC shipment is not available. Reasons were not copied to all lines.'
    );
    return Promise.resolve(null);
  }
  let dataSent = saveEvent({
    psc: {
      lineCodes: lineCodes,
    },
    shipmentId: window.pscShipmentId,
  });
  console.log('UPDATE BULK LINE REASONS', dataSent);
  showPscBulkLineReasonLoader();
  return HttpPostRequest(dataSent).finally(() => {
    hidePscBulkLineReasonLoader();
  });
};

export const savePscData  = (payload) => {
  if(!window.pscShipmentId){
    console.error("PSC ShipmentId doesnot exist");
  }
  let dataSent = saveEvent({
     "psc": {
        ...payload
      },
    "shipmentId": window.pscShipmentId,
  });
  console.log("UPDATE PSC DATA", dataSent);
  return HttpPostRequest(dataSent);
}


export const addNotesItem = (description,createdBy ,hotCheckBox, code, noteId) => {
 
  let dataSent = {
  eventType: "SAVE_SHIPMENT_NOTES",
  eventTime: Date.now(),
  eventMessage :{
      noteId,
      code,
      shipmentId: window.shipmentId , 
      status : "0",
      description,
      "hot" : hotCheckBox === true ? "1" :"0",
      userName :createdBy,
      dateOfNote : {epochs: (new Date).getTime() }  
  }
  }

  return dataSent;

}


export const callManufacturerAutosuggestAPI = (text) =>{

  const data = {
    eventMessage: "1,"+text,//the 1 signifies manufacturer!
    eventType: "GET_ACTOR_REF_ANY",
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const callAutosuggestAPI = (text,api) =>{

  const data = {
    eventMessage: text,
    eventType: api,
    eventTime: Date.now()
  }
  return HttpClient.custom({
    data
  })
}

export const saveNotes = (noteId, fieldName, value ) =>{
  let dataSent ={
      eventType: "SAVE_SHIPMENT_NOTES",
      eventTime: Date.now(),
      eventMessage: 
      {
        noteId,
        [fieldName]: value,
        shipmentId: window.shipmentId
      },
    


  };

  return HttpPostRequest(dataSent);
}

export const saveAdditionDeduction = (dataKey,data,callback) => {
   let extraParams = { eventType:"PRORATE_ADDITION_DEDUCTION"}
 
  let dataSent = saveEvent({
    descriptionOfMerchandise: {[dataKey] :data},
    shipmentId: window.pscShipmentId || window.shipmentId,
  },extraParams);
  //console.log("SAVE DescriptionOfMerchandiseField", dataSent);
  return HttpPostRequest(dataSent).then(response => {
        const eventMessage = response.data.eventMessage;
  
        if (!eventMessage?.warnings) {
          store.dispatch(updateAdditonDeduction(eventMessage));
        }
        else{
          let errorMsg=get(eventMessage, "warnings.msg", "Data is not saved ");
           toast.error(errorMsg)
        }
      })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
         callback && callback();
        });
};
export const saveAdditionDeductionAtInvLevel = (invoiceId,data,callback) => {
   let extraParams = { eventType:"PRORATE_ADDITION_DEDUCTION"}
  let dataSent = saveEntrySummaryDutiesEvent_vc({
    descriptionOfMerchandise: {
      entrySummaryInvoices: [{
        invoiceId,
        ...data,
        shipmentId: window.pscShipmentId || window.shipmentId,
      }],
    },
    shipmentId: window.pscShipmentId || window.shipmentId,
  },
  extraParams
  );
   return HttpPostRequest(dataSent).then(response => {
         const eventMessage = response.data.eventMessage;
   
         if (!eventMessage?.warnings) {
           store.dispatch(updateAdditonDeduction(eventMessage));
         }
         else{
          let errorMsg=get(eventMessage, "warnings.msg", "Data is not saved ");
          toast.error(errorMsg)
         }
       })
         .catch(error => {
           console.error(error);
         })
         .finally(() => {
          callback && callback();
         });
  
};

export const saveAdditionalDeclaration = async ({ invoiceId, merchandiseId, shipmentId, information, typeCode, isDelete = false }) => {
  const payload = {
    eventType: 'SAVE_ENTRY_SUMMARY_DUTIES',
    eventTime: Date.now(),
    eventMessage: {
      descriptionOfMerchandise: {
        entrySummaryInvoices: [
          {
            invoiceId,
            merchandiseLineItems: [
              {
                merchandiseId,
                importerAdditionalDeclarationDetails: {
                  importerAdditionalDeclarationDetail: [
                    {
                      information: isDelete ? '_BLANK_' : information,
                      typeCode,
                    },
                  ],
                },
              },
            ],
          },
        ],
      },
      shipmentId,
    },
  };

  return HttpClient.custom({ data: payload })
    .catch((error) => {
      console.error('Failed to save declaration', error);
      toast.error('Data not saved. Try again later');
      throw error;
    });
};

